import { WbResponseError } from './InterWbResponseError';
export class WbHttpError extends WbResponseError {
    constructor(message, httpStatus, action) {
        super(message, action);
        this.httpStatus = httpStatus;
        this.response = message;
    }
}
